import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormControl from 'react-bootstrap/lib/FormControl';
import classNames from 'classnames';

export default function InputDropdown(props) {
    const { text, placeholder, onDropdown, ...rest } = props;
    const [isVisible, setVisible] = useState(false);
    const arrow = isVisible ? 'fa-angle-up' : 'fa-angle-down';

    function handleOnDropdown() {
        if (onDropdown) {
            onDropdown(!isVisible);
        }

        setVisible(!isVisible);
    }

    return (
        <div className="input-dropdown">
            <span
                className={classNames('input-dropdown-text', { space: isVisible })}
                onClick={handleOnDropdown}
            >
                <i className={classNames('fa', arrow)} />
                {text}
            </span>
            <FormControl
                type="text"
                className={classNames({ hidden: !isVisible })}
                placeholder={placeholder}
                {...rest}
            />
        </div>
    );
}

InputDropdown.propTypes = {
    text: PropTypes.string,
    placeholder: PropTypes.string,
    onDropdown: PropTypes.func
};
